import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/degenerate/cdf';
import __var_2__ from '@stdlib/stats/base/dists/degenerate/ctor';
import __var_3__ from '@stdlib/stats/base/dists/degenerate/entropy';
import __var_4__ from '@stdlib/stats/base/dists/degenerate/logcdf';
import __var_5__ from '@stdlib/stats/base/dists/degenerate/logpdf';
import __var_6__ from '@stdlib/stats/base/dists/degenerate/logpmf';
import __var_7__ from '@stdlib/stats/base/dists/degenerate/mean';
import __var_8__ from '@stdlib/stats/base/dists/degenerate/median';
import __var_9__ from '@stdlib/stats/base/dists/degenerate/mgf';
import __var_10__ from '@stdlib/stats/base/dists/degenerate/mode';
import __var_11__ from '@stdlib/stats/base/dists/degenerate/pdf';
import __var_12__ from '@stdlib/stats/base/dists/degenerate/pmf';
import __var_13__ from '@stdlib/stats/base/dists/degenerate/quantile';
import __var_14__ from '@stdlib/stats/base/dists/degenerate/stdev';
import __var_15__ from '@stdlib/stats/base/dists/degenerate/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace degenerate
*/
var degenerate = {};

/**
* @name cdf
* @memberof degenerate
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/degenerate/cdf}
*/
setReadOnly( degenerate, 'cdf', __var_1__);

/**
* @name Degenerate
* @memberof degenerate
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/degenerate/ctor}
*/
setReadOnly( degenerate, 'Degenerate', __var_2__);

/**
* @name entropy
* @memberof degenerate
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/degenerate/entropy}
*/
setReadOnly( degenerate, 'entropy', __var_3__);

/**
* @name logcdf
* @memberof degenerate
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/degenerate/logcdf}
*/
setReadOnly( degenerate, 'logcdf', __var_4__);

/**
* @name logpdf
* @memberof degenerate
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/degenerate/logpdf}
*/
setReadOnly( degenerate, 'logpdf', __var_5__);

/**
* @name logpmf
* @memberof degenerate
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/degenerate/logpmf}
*/
setReadOnly( degenerate, 'logpmf', __var_6__);

/**
* @name mean
* @memberof degenerate
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/degenerate/mean}
*/
setReadOnly( degenerate, 'mean', __var_7__);

/**
* @name median
* @memberof degenerate
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/degenerate/median}
*/
setReadOnly( degenerate, 'median', __var_8__);

/**
* @name mgf
* @memberof degenerate
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/degenerate/mgf}
*/
setReadOnly( degenerate, 'mgf', __var_9__);

/**
* @name mode
* @memberof degenerate
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/degenerate/mode}
*/
setReadOnly( degenerate, 'mode', __var_10__);

/**
* @name pdf
* @memberof degenerate
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/degenerate/pdf}
*/
setReadOnly( degenerate, 'pdf', __var_11__);

/**
* @name pmf
* @memberof degenerate
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/degenerate/pmf}
*/
setReadOnly( degenerate, 'pmf', __var_12__);

/**
* @name quantile
* @memberof degenerate
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/degenerate/quantile}
*/
setReadOnly( degenerate, 'quantile', __var_13__);

/**
* @name stdev
* @memberof degenerate
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/degenerate/stdev}
*/
setReadOnly( degenerate, 'stdev', __var_14__);

/**
* @name variance
* @memberof degenerate
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/degenerate/variance}
*/
setReadOnly( degenerate, 'variance', __var_15__);


// EXPORTS //
export default degenerate;

export { __var_1__ as cdf, __var_2__ as Degenerate, __var_3__ as entropy, __var_4__ as logcdf, __var_5__ as logpdf, __var_6__ as logpmf, __var_7__ as mean, __var_8__ as median, __var_9__ as mgf, __var_10__ as mode, __var_11__ as pdf, __var_12__ as pmf, __var_13__ as quantile, __var_14__ as stdev, __var_15__ as variance};